module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Draycott Everlasting")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "rev01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagei"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_vm._v("Praise for works by"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "ss"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHRISTINA SKYE")])])])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("TO CATCH A THIEF")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Fast-paced action, vivid detail, a touch of the paranormal, and hot lovemaking will please readers of adventure romance, while fans of Skye’s Draycott Abbey and Code Name series will enjoy this clever union of the two.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("—Booklist")])])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CODE NAME: BIKINI")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“A fun, antic read.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("—Publishers Weekly")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Fast-paced action, flashes of humor, and futuristic flavor typify this romantic action-adventure. Fans of the Code Name series will enjoy this delicious addition.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—Kristin Ramsdell, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Library Journal")])])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CODE NAME: BLONDIE")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Romantic thrills and adventure from the expert.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("RT Book Reviews")])])])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Skye is terrific at writing fast-paced adventure romances…a tantalizing addition to the compelling Code Name series.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("—Booklist")])])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CODE NAME: BABY")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Thrilling…fans should eagerly await the next in the series.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("—Publishers Weekly")])])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("THE DRAYCOTT LEGACY")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Christina Skye’s delightfully haunting Draycott Abbey tales…pass the test of time, as they remain some of the better romantic fantasies available.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—Harriet Klausner")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagei"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4695d15a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/draycotteverlasting_rev01.vue
// module id = 57
// module chunks = 0